// filter.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mobileFilter' })
export class FilterPipe implements PipeTransform {

  // Transform
  // @param {IValue[]} items
  // @param {string} searchText
  // @returns {IValue[]}

  transform(items: any[], searchText: string): any[] {
    if (items == null) {
      return null;
    }

    if (!items) {
      return null;
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toString();
    return items.filter(it => {
      if (it.phone) {
        return it.phone?.replace(/\s/g, '').includes(searchText);
      } else if (it.mobilePhone) {
        return it.mobilePhone?.replace(/\s/g, '').includes(searchText);
      }
    });
  }
}
